import {AxiosError} from 'axios';
import {PUT_EDIT_USER_GROUP_URL} from 'web-library/constants/apiUrls';
import {
  CreateEditNewUserGroupRequestBody
} from 'web-library/models/UserGroupAccessConfiguration/UserGroupAccessConfiguration';
import axiosClient from '../axiosClient';
import {useCustomMutation} from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";

interface Input {
  onSuccess?: (res: void) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
  uuid: string;
}

export const usePutEditUserGroup = ({onError, onSuccess, uuid}: Input) => {
  const putEditUserGroup = async (reqBody: CreateEditNewUserGroupRequestBody) => {
    const res = await axiosClient.put<void>(PUT_EDIT_USER_GROUP_URL(uuid), reqBody);

    return res.data;
  };

  return useCustomMutation(putEditUserGroup, {
    onSuccess,
    onError,
  });
};
